module.exports = __webpack_public_path__ + "img/banner.b14101dc.png";